import { mutatorAction } from "satcheljs";
import { ShiftRequestPanelSelectedItemType, shiftRequestsPanelStore } from "../";

export default mutatorAction('SET_SELECTED_ITEM_TYPE',
    function setSelectedItemType(selectedItemType: ShiftRequestPanelSelectedItemType) {
        shiftRequestsPanelStore().selectedItemType = selectedItemType;
    }
);
